import styled from "styled-components";

export const ColorPickerContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
`;

export const ColorPicker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .react-colorful {
    width: 200px;
    height: 150px;
  }

  .react-colorful__saturation {
    border-radius: 4px 4px 0 0;
  }

  .react-colorful__hue {
    border-radius: 0 0 4px 4px;
  }
`;

export const ColorSwatches = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 6px;
`;

export const ColorSwatch = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.$color};
  cursor: pointer;
  border: 2px solid #e5e7eb;
  transition: transform 0.1s ease;

  &:hover {
    transform: scale(1.1);
    border-color: #9ca3af;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ColorIndicator = styled.div`
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 3px;
  background-color: ${(props) => props.$color};
  border-radius: 2px;
`;
